import {base64StrToBlob} from "../helpers/common";
import {API_ENDPOINTS} from "../constants/apiConstants";
import {apiCommonManager} from "../store/apiCommonManager";
import {REACT_APP_CMS_URL} from "../constants/envConstants";
import {isApiSuccess} from "../store/apiManager";

export const fetchPdfMediaService = async (
    filePath: string,
    returnBlob = false,
    defaultType = 'application/pdf; charset=utf-8'
) => {
    const resp = await apiCommonManager.request(
        API_ENDPOINTS.GET_PDF_MEDIA(filePath),
        {},
        'GET',
        "",
        REACT_APP_CMS_URL
    );

    if (resp?.status && isApiSuccess(resp.status) && resp?.data) {
        const type = resp.headers['Content-Type'];
        const mediaBlob = base64StrToBlob(
            resp.data,
            typeof type === 'string' ? type : defaultType
        );
        return returnBlob ? mediaBlob : URL.createObjectURL(mediaBlob);
    }
};
